// src/components/auth/GoogleOAuthButton.tsx - Updated version
import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

interface GoogleOAuthButtonProps {
  onSignIn: () => void;
  loading?: boolean;
  text?: string;
  disabled?: boolean; // Added disabled prop
}

const GoogleIcon: React.FC = () => (
  <svg width="18" height="18" viewBox="0 0 18 18">
    <path
      fill="#4285F4"
      d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18Z"
    />
    <path
      fill="#34A853"
      d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2.04a4.8 4.8 0 0 1-2.7.75c-2.09 0-3.86-1.4-4.49-3.31H1.83v2.07A8 8 0 0 0 8.98 17Z"
    />
    <path
      fill="#FBBC04"
      d="M4.49 10.46a4.8 4.8 0 0 1 0-3.04V5.35H1.83a8 8 0 0 0 0 7.22l2.66-2.11Z"
    />
    <path
      fill="#EA4335"
      d="M8.98 3.58c1.18 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 8.98 1a8 8 0 0 0-7.15 4.35l2.66 2.07c.63-1.9 2.4-3.31 4.49-3.31Z"
    />
  </svg>
);

export const GoogleOAuthButton: React.FC<GoogleOAuthButtonProps> = ({
  onSignIn,
  loading = false,
  disabled = false, // Added disabled handling
  text = 'Continue with Google',
}) => {
  const handleClick = () => {
    if (loading || disabled) return;
    onSignIn();
  };

  return (
    <motion.button
      whileTap={{ scale: loading || disabled ? 1 : 0.98 }}
      onClick={handleClick}
      disabled={loading || disabled}
      className="w-full flex items-center justify-center px-4 py-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {loading ? (
        <div className="flex items-center space-x-3">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span className="text-sm font-medium">Redirecting...</span>
        </div>
      ) : (
        <>
          <GoogleIcon />
          <span className="ml-3 text-sm font-medium">{text}</span>
        </>
      )}
    </motion.button>
  );
};